<template>
    <div data-cy="passwordConfig">
        <div v-if="onlyFields === 'true'">
            <br />

            {{ $t('passAccount.SQ.question') }} 1

            <v-select
                @change="
                    onSelect($event, 1);
                    checkIsValid();
                "
                :items="secretQuestions"
                item-text="content"
                v-model="fields.firstSQ"
                required
                name="SQSelectQuestion1Reset"
                color="#3200E6"
            >
            </v-select>
            {{ $t('passAccount.SQ.answer') }}
            <v-text-field color="#3200E6" v-model="fields.firstAnswer" @keyup.native="checkIsValid()" name="SQSelectAnswer1Reset" />

            {{ $t('passAccount.SQ.question') }} 2

            <v-select
                @change="
                    onSelect($event, 2);
                    checkIsValid();
                "
                :items="remainingSQ"
                item-text="content"
                v-model="fields.secondSQ"
                required
                name="SQSelectQuestion2Reset"
                color="#3200E6"
            >
            </v-select>
            {{ $t('passAccount.SQ.answer') }}
            <v-text-field
                color="#3200E6"
                v-model="fields.secondAnswer"
                @keyup.native="checkIsValid()"
                name="SQSelectAnswer2Reset"
                data-cy="question2Answer"
            />
            <v-alert v-if="answerLengthWarning" dense outlined type="error">
                {{ $t('passAccount.SQ.answerLengthWarning') }}
            </v-alert>
            <v-alert v-if="currPwdWarning" dense outlined type="error">
                {{ $t('passAccount.common.currPwdWarning') }}
            </v-alert>
            <v-alert v-if="sameAnswersWarning" dense outlined type="error">
                {{ $t('passAccount.SQ.sameAnswersWarning') }}
            </v-alert>
        </div>
        <v-form @submit.prevent ref="form" v-else>
            <v-card class="tab-card">
                <v-container>
                    <v-card-title>{{ $t('passAccount.header.changeSQ') }}</v-card-title>
                    <v-card-text>
                        {{ $t('passAccount.common.currentPassword') }}
                        <v-text-field
                            color="#3200E6"
                            :append-icon="showPwd ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                            @click:append="() => (showPwd = !showPwd)"
                            :type="showPwd ? 'password' : 'text'"
                            v-model="fields.currentPwd"
                            data-cy="passwordSecretQuestionsConfig"
                        />
                    </v-card-text>

                    <v-spacer></v-spacer>

                    <small>{{ $t('passAccount.SQ.purpose') }}</small>

                    <br />
                    <br />
                    <br />

                    <small>{{ $t('passAccount.SQ.question') }} 1</small>

                    <v-select
                        @change="onSelect($event, 1)"
                        :items="secretQuestions"
                        item-text="content"
                        v-model="fields.firstSQ"
                        required
                        color="#3200E6"
                        id="selectQuestion1"
                    >
                    </v-select>
                    <v-card-text>
                        {{ $t('passAccount.SQ.answer') }}
                        <v-text-field data-cy="question1Answer" color="#3200E6" v-model="fields.firstAnswer" />
                    </v-card-text>

                    <small>{{ $t('passAccount.SQ.question') }} 2</small>

                    <v-select
                        @change="onSelect($event, 2)"
                        :items="remainingSQ"
                        item-text="content"
                        v-model="fields.secondSQ"
                        required
                        color="#3200E6"
                        id="selectQuestion2"
                    >
                    </v-select>
                    <v-card-text>
                        {{ $t('passAccount.SQ.answer') }}
                        <v-text-field data-cy="question2Answer" color="#3200E6" v-model="fields.secondAnswer" />
                    </v-card-text>
                    <v-alert data-cy="answerLengthWarning" v-if="answerLengthWarning" dense outlined type="error">
                        {{ $t('passAccount.SQ.answerLengthWarning') }}
                    </v-alert>
                    <v-alert data-cy="currPwdWarning" v-if="currPwdWarning" dense outlined type="error">
                        {{ $t('passAccount.common.currPwdWarning') }}
                    </v-alert>
                    <v-alert data-cy="sameAnswersWarning" v-if="sameAnswersWarning" dense outlined type="error">
                        {{ $t('passAccount.SQ.sameAnswersWarning') }}
                    </v-alert>
                    <v-btn data-cy="saveConfigQuestions" :disabled="!isValid" class="action" @click="submit">
                        {{ $t('global.saveButton') }}
                    </v-btn>
                    <v-btn data-cy="cancelConfigQuestions" class="cancel" @click="cancelSQChange">
                        {{ $t('global.cancelButton') }}
                    </v-btn>
                </v-container>
            </v-card>
        </v-form>
        <v-snackbar v-model="snackbar.display" :timeout="snackbar.timeout" id="messageInfo">
            {{ snackbar.text }}
        </v-snackbar>
    </div>
</template>

<script>
import { api } from '@utils/api';
import { i18n } from '@plugins/vuetify';
export default {
    props: ['onlyFields'],
    data() {
        return {
            fields: {
                currentPwd: '',
                firstSQ: '',
                secondSQ: '',
                firstAnswer: '',
                secondAnswer: ''
            },
            snackbar: {
                display: false,
                text: '',
                timeout: 2000
            },
            // remainingSQ: [],
            showPwd: 'password'
        };
    },
    methods: {
        clearForm() {
            this.fields = {
                currentPwd: '',
                firstSQ: '',
                secondSQ: '',
                firstAnswer: '',
                secondAnswer: ''
            };
        },
        async submit() {
            const data = {
                currentPassword: this.fields.currentPwd,
                secretQuestions: [
                    {
                        secretQuestion: this.fields.firstSQ,
                        secretAnswer: this.fields.firstAnswer
                    },
                    {
                        secretQuestion: this.fields.secondSQ,
                        secretAnswer: this.fields.secondAnswer
                    }
                ]
            };
            if (this.onlyFields === 'true') {
                let informations = this.$session.get('accMgmt-configuration-informations');
                if (informations) {
                    informations = JSON.parse(decodeURIComponent(escape(atob(informations))));
                    data.geodisLogin = informations.geodisLogin;
                }
            }
            const result = await api.patch('sqChange', data, null, 'accMgmt');
            if (this.onlyFields === 'true') {
                return this.$emit('sq-changed', result);
            }
            if (result) {
                this.snackbar.text = i18n.t('passAccount.SQ.sqChanged');
                this.snackbar.display = true;
            } else {
                this.snackbar.text = i18n.t('passAccount.common.wrongCurrPwd');
                this.snackbar.display = true;
            }
            this.clearForm();
        },
        cancelSQChange() {
            this.$router.push('/accMgmt');
        },
        onSelect(e, dropdownId) {
            const currentDropdown = dropdownId === 1 ? this.secretQuestions : this.remainingSQ;
            const otherDropdown = dropdownId === 1 ? this.remainingSQ : this.secretQuestions;
            if (e.length) {
                const chosen = currentDropdown.filter(item => item.content === e);
                otherDropdown.forEach(item => {
                    if (item.content === chosen[0].content) {
                        item.disabled = true;
                    } else {
                        item.disabled = false;
                    }
                });
            }
        },
        checkIsValid() {
            const check =
                this.fields.currentPwd &&
                this.fields.firstAnswer &&
                this.fields.firstSQ &&
                this.fields.firstAnswer.length >= 3 &&
                this.fields.secondAnswer &&
                this.fields.secondSQ &&
                this.fields.secondAnswer.length >= 3 &&
                this.fields.firstAnswer !== this.fields.secondAnswer;
            this.$emit('sq-is-valid', check);
            return check;
        }
    },
    computed: {
        secretQuestions: function () {
            const SQ = this.$store.getters.getSQ;
            const currentLang = this.$i18n.locale;

            SQ.forEach(function (element) {
                element.disabled = false;
                element.content = element[currentLang.toLowerCase()];
            });

            return SQ;
        },
        remainingSQ: function () {
            return JSON.parse(JSON.stringify(this.secretQuestions));
        },
        isValid: function () {
            return this.checkIsValid();
        },
        answerLengthWarning: function () {
            if (this.fields.firstAnswer || this.fields.secondAnswer) {
                return this.fields.firstAnswer.length < 3 || this.fields.secondAnswer.length < 3;
            }
            return false;
        },
        currPwdWarning: function () {
            if (this.fields.firstAnswer && this.fields.secondAnswer) {
                return !this.fields.currentPwd;
            }
            return false;
        },
        sameAnswersWarning: function () {
            if (!this.answerLengthWarning && this.fields.firstAnswer && this.fields.firstAnswer === this.fields.secondAnswer)
                return true;
            return false;
        }
    },
    mounted() {
        if (this.onlyFields === 'true') {
            this.fields.currentPwd = 'anonymous';
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.service {
    cursor: pointer;
    border-top: 7px solid #fff;
    .v-card__subtitle {
        padding-top: 10px;
        padding-bottom: 21px;
    }
    .goto {
        color: $primary;
        border-radius: 50% !important;
        position: absolute;
        right: 10px;
        bottom: 20px;
    }
    &:hover {
        border-top: 7px solid $primary;
        .goto {
            background-color: $primary;
            color: #fff;
        }
    }
}
.v-text-field {
    width: 400px;
}

button.action {
    margin: 20px 10px 10px 10px;
}

button.cancel {
    margin: 20px 10px 10px 20px;
}

.tab-card {
    margin: 20px 0px 0px 20px;
    .header {
        .actions {
            .v-btn {
                margin-left: 20px;
            }
        }
    }
    h3 {
        padding: 15px;
    }
}
.v-alert {
    width: 400px;
}
</style>
